import {useEffect, useRef, useState, useMemo} from "react";
import TOCLink from "@/components/TOCLink";

export default function TableOfContents({toc, activeSection, minLevel, onTOCClick}) {
    const lastPosition = useRef(0);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true)
    }, [])

    useEffect(() => {
        if (!isClient) return;
        
        const container = document.getElementById('toc-container');
        const activeLink = document.getElementById(`link-${activeSection}`);

        if (container && activeLink) {
            // Get container properties
            const cTop = container.scrollTop;
            const cBottom = cTop + container.clientHeight;

            // Get activeLink properties
            const lTop = activeLink.offsetTop - container.offsetTop;
            const lBottom = lTop + activeLink.clientHeight;

            // Check if in view
            const isTotal = lTop >= cTop && lBottom <= cBottom;

            const isScrollingUp = lastPosition.current > window.scrollY;
            lastPosition.current = window.scrollY;

            if (!isTotal) {
                // Scroll by the whole clientHeight
                const offset = 25;
                const top = isScrollingUp
                    ? lTop - container.clientHeight + offset
                    : lTop - offset;

                container.scrollTo({ top, behavior: 'smooth' });
            }
        }
    }, [activeSection, isClient]);
    // Memoize TOC items to prevent unnecessary re-renders
    const tocItems = useMemo(() => {
        if (!toc) return null;

        // Filter out items without valid IDs
        return toc
            .filter(({ id }) => id && id.trim() !== '')
            .map(({ id, level, text }, index) => (
                <TOCLink
                    id={id}
                    key={id || `toc-item-${index}`}
                    activeSection={activeSection}
                    level={level}
                    minLevel={minLevel}
                    text={text}
                    onTOCClick={onTOCClick}
                />
            ));
    }, [toc, activeSection, minLevel, onTOCClick]);

    return (
        <div
            id='toc-container'
            className='hidden max-h-[calc(100vh-9rem-113px)] overflow-hidden pb-4 lg:block pt-5'
        >
            <div className='sr-only'>Table of Contents</div>
            <div className='flex flex-col space-y-2 text-sm'>
                {tocItems}
            </div>
        </div>
    )
}